<template>
	<div class="host-component">
		<transition name="host-flip" appear>
			<div class="host spinning">
				<img class="host-medallion front" src="@/assets/images/host-front.png" alt="Host" />
				<img class="host-medallion back" src="@/assets/images/host-back.png" alt="Host" />
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'Host',
	mounted() {
		this.$store.dispatch("sound/fx/play", { id: "host_enter" });
	},
};
</script>

<style lang="scss" scoped>
	.host-component {
		position: relative;
		width: 80%;
		perspective: 800px;

		@include tablet {
			width: auto;
			height: 60vmin;
		}
	}

	.host {
		height: 100%;
		display: inline-block;
		position: relative;
		transform-style: preserve-3d;

		&.spinning {
			animation: host-flip 3s forwards;
		}
	}

	.host-medallion {
		position: relative;
		max-height: 100%;
		max-width: 100%;

		z-index: $z-top;
		backface-visibility: hidden;

		&.back {
			position: absolute;
			top: 0;
			left: 0;

			z-index: $z-mid;
			transform: rotateY(180deg);
		}
	}
</style>
